import { BehaviorSubject } from 'rxjs';

export class OneTimeValue<T> {
  private subject: BehaviorSubject<T | null>;

  constructor(initialValue: T | null) {
    this.subject = new BehaviorSubject<T | null>(initialValue);
  }

  read(): T | null {
    const value = this.subject.getValue(); // Get the current value
    this.subject.next(null); // Reset to null after reading
    return value;
  }

  set(value: T): void {
    this.subject.next(value);
  }

  asObservable() {
    return this.subject.asObservable(); // Expose as an observable
  }
}
